interface KidneysOrganIconProps {
  className?: string
  size?: number
}

export function KidneysOrganIcon({
  className,
  size = 32,
}: KidneysOrganIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
      className={className}
    >
      <path
        fill="currentColor"
        d="M28.324 7.874c-.997-2.371-3.317-3.939-5.913-3.996h-.228c-2.287.072-4.116 1.899-4.167 4.16q-.027.506.055 1.006c.198 1.216.206 2.534.023 3.92-.067.51-.093.886-.078 1.153q.003.132.015.262l-1.022 1.29a1.5 1.5 0 0 0-.322.921v11.53h.986V16.59c0-.115.04-.229.112-.32l.534-.675a4.3 4.3 0 0 0 3.864 2.682h.161c2.535-.047 4.831-1.56 5.854-3.854l.069-.143a7.64 7.64 0 0 0 .057-6.406m-.949 5.991-.069.142-.008.016c-.865 1.951-2.815 3.239-4.968 3.28h-.123c-1.762-.059-3.17-1.47-3.207-3.214v-.018c-.01-.14-.003-.423.07-.98.195-1.479.186-2.892-.027-4.201A3.7 3.7 0 0 1 19 8.084v-.017c.037-1.744 1.444-3.154 3.206-3.213h.189a5.58 5.58 0 0 1 5.021 3.4l.006.013a6.67 6.67 0 0 1-.046 5.599M16.25 28.122h.002zM15.93 15.67l-.972-1.168q.021-.19.026-.384c.015-.268-.01-.645-.078-1.154-.183-1.385-.175-2.704.024-3.92a4.7 4.7 0 0 0 .055-1.006c-.053-2.262-1.881-4.088-4.168-4.16h-.23c-2.595.057-4.915 1.625-5.911 3.996a7.63 7.63 0 0 0 .056 6.406l.07.143c1.022 2.295 3.318 3.807 5.853 3.854h.161a4.3 4.3 0 0 0 3.835-2.61l.506.607c.07.09.11.203.11.317v11.53h.984v-11.53c0-.332-.114-.66-.322-.921m-5.137 1.633h-.124v.001c-2.154-.041-4.104-1.328-4.97-3.28l-.076-.158a6.67 6.67 0 0 1-.046-5.599l.006-.012a5.58 5.58 0 0 1 5.021-3.4h.189c1.762.058 3.17 1.469 3.207 3.213v.017c.014.268 0 .54-.043.805-.214 1.31-.223 2.723-.028 4.201.074.557.08.84.07.98v.018c-.036 1.745-1.444 3.155-3.206 3.214"
      />
    </svg>
  )
}
